export default __webpack_public_path__ + "static/media/LLNL_Award.1d41240d.png";